import Dropdown from "rc-dropdown";
import Menu from "rc-menu";
import "rc-dropdown/assets/index.css";
import { ArrowIcon, CloseIcon } from "components/icons";

type IDropdownComponentProps = {
  options: string[];
  selectedItem: string;
  setSelectedItem: (option: string) => void;
  onRemoveItem?: () => void;
  clearable?: boolean;
};

const DropdownComponent: React.FC<IDropdownComponentProps> = ({
  options,
  selectedItem,
  clearable,
  setSelectedItem,
  onRemoveItem,
}) => {
  const menu = (
    <Menu
      onClick={({ key }) => setSelectedItem(key)}
      selectedKeys={[selectedItem]}
      style={{
        borderRadius: "8px",
        border: "none",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      {options.map((item) => (
        <Menu.Item
          key={item}
          style={{
            padding: "4px 12px",
            cursor: "pointer",
            fontSize:"14px",
            backgroundColor: selectedItem === item ? "#EEF2FF" : "white",
            color: selectedItem === item ? "#2563EB" : "#525252",
            transition: "all 0.2s ease", // 添加过渡效果
          }}
          // // hover 样式通过 CSS 类实现
          // className="hover:bg-[#F8FAFC] hover:text-[#2563EB]"
        >
          {item}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown trigger={["click"]} overlay={menu} animation="slide-up">
      <div
        // className="
        //   flex flex-row items-center justify-center gap-[12px] 
        //   py-[4px] px-[8px] rounded-[16px] 
        //   bg-white text-[#4338CA]
        //   border border-solid border-[#4338CA]
        //   cursor-pointer w-fit 
        //   transition-all duration-200
        //   appearance-none
        //   group
        // "

        className="flex flex-row py-[6px] px-2 justify-center item items-center gap-[4px] rounded-[16px] bg-[rgba(148,163,184,0.20)] text-[14px] font-medium text-[#525252] cursor-pointer"
      >
        <span>
          {selectedItem}
        </span>
        <span className=" flex-row items-center justify-center w-[13px] h-[13px] flex">
          <ArrowIcon />
        </span>

        {clearable && (
          <span
            className="flex-row items-center justify-center hidden w-[13px] h-[13px] rounded-full flex-shrink-0 bg-[rgba(148,163,184,0.20)] group-hover:flex"
            onClick={onRemoveItem}
          >
            <CloseIcon width={8} height={12} />
          </span>
        )}
      </div>
    </Dropdown>
  );
};

export default DropdownComponent;
